import { baseCreateUrl } from './cloudinary.common';

export const FETCH_API_URL = 'https://cdn.apartmenttherapy.info/image/fetch';
const prefix = FETCH_API_URL.replace(/([./])/g, '\\$1');
export const SERVICE_REGEXP = new RegExp(`^${prefix}`);
export const EXTRACT_REGEXP = new RegExp(`^(?:${prefix}.+)?(https?://.+)$`);

/**
 * returns original storage (source) URL of image if the passed URL is a
 * cloudinary fetch URL. if not, returns passed URL.
 *
 * @param {String} url image URL, possibly a full cloudinary fetch URL
 * @return {String} original storage URL
 */
export function extractStorageUrl(url) {
  const matches = EXTRACT_REGEXP.exec(url);
  return matches && matches.length > 1 ? matches[1] : url;
}

/**
 * returns true if this service can handle the passed image URL
 *
 * hardcoded to return true because fetch can handle any image URL
 *
 * @export
 * @param {String} url fully-qualified URL to image
 * @returns {Boolean}
 */
// eslint-disable-next-line no-unused-vars
export function testUrl(url) {
  return true;
}

/**
 * returns a cloudinary URL for the image via the "fetch" API.
 *
 * see https://cloudinary.com/documentation/fetch_remote_images
 *
 * accepts renderOps object or array of renderOps, which is henceforth called
 * "transforms".
 *
 * @export
 * @param {String} imageUrl canonical image URL
 * @param {Object|Object[]} [options={}] service-agnostic render options (or an array of render options)
 * @returns {String} cloudinary image URL with translated renderOptions
 */
export function createUrl(imageUrl, options = {}) {
  const storageUrl = extractStorageUrl(imageUrl);
  // Encode URLs so `?`, etc, will not break the call. Unfortunately some URLs
  // are already encoded, but there is no good way to tell. To prevent double
  // encoding we need to decodeURIComponent first.
  let encodedUrl = storageUrl;
  try {
    // Protect against "URIError: URI malformed"
    encodedUrl = encodeURIComponent(decodeURIComponent(storageUrl));
  } catch (e) {
    console.error(e); // eslint-disable-line
  }

  return baseCreateUrl.call(null, FETCH_API_URL, encodedUrl, options);
}

/** consumers import default; specs import named exports */
export default {
  testUrl,
  createUrl
};
